<template>
    <ui-dropdown placement="bottom-start" menu-class="flex" trigger-class="flex-1">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto w-full">

                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    Start typing to search for known materials...
                </div>
                <!-- Results -->
                <div v-else class="space-y-6">
                    <div v-if="materials.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Materials</div>
                        <div class="space-y-1">
                            <div v-for="material in materials" class="w-full">
                                <button @click="selectMaterial(material.name, close)"
                                        class="text-left px-1.5 py-0.5 -my-0.5 w-full border border-transparent rounded-lg text-s font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 text-blue-500 hover:text-gray-600">
                                    {{ material.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching materials found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        store: Object
    },
    data() {
        return {
            query: '',
            materials: [],
        }
    },
    computed: {},
    methods: {
        async searchMaterials() {
            if (this.store.loaded) {
                this.materials = this.store.materials.filter(this.matchContact).sort((a, b) => {
                    let score = 0;
                    return score;
                }).slice(0, 100);
            }
        },
        matchContact(material) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (material.name).toLowerCase().includes(token);
            });
        },
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
            this.searchMaterials();
        },
        selectMaterial(materialName, close) {
            this.$emit('selected:material', {materialName});
            this.query = materialName;
            close();
        },
    },
}
</script>
